import { useEffect, useState } from 'react';
import { usePedidos } from '../../../../contexts/Pedidos';
import { useHistory } from 'react-router-dom';
import { FieldDropdownVer2 } from '../../../../themes/components/FieldDropdown';
import { ArrayClientes, ArrayCondicaoPagamento, ArrayFormaPagamento, Cliente, CondicaoPagamento, FormaPagamento } from '../../interfaces';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';

interface Cabecalho {
    setFieldCondPagamento?: React.Dispatch<React.SetStateAction<CondicaoPagamento | undefined>>,
    setFieldFormaPagamento?: React.Dispatch<React.SetStateAction<FormaPagamento | undefined>>,
    setFieldCliente?: React.Dispatch<React.SetStateAction<Cliente | undefined>>,
    fieldCondPagamento?: CondicaoPagamento | undefined,
    fieldFormaPagamento?: FormaPagamento | undefined,
    fieldCliente?: Cliente | undefined,
}

export const CabecalhoNovoPedido = (props: Cabecalho) => {
    let history = useHistory();
    const { buscarClientes, buscarCondPGTO, buscarFormaPGTO, setNovoPedido, novoPedido } = usePedidos();
    const [loadingCliente, setLoadingCliente] = useState<boolean>(false);
    const [loadingCondicaoPGTO, setLoadingCondicaoPGTO] = useState<boolean>(false);
    const [loadingFormaPGTO, setLoadingFormaPGTO] = useState<boolean>(false);
    const [listaClientes, setListaClientes] = useState<ArrayClientes>();
    const [listaCondPGTO, setListaCondPGTO] = useState<ArrayCondicaoPagamento>();
    const [listaFormaPGTO, setListaFormaPGTO] = useState<ArrayFormaPagamento>();

    function handleChangeCliente(event: any, option: string, reason: any) {
        async function getCliente() {
            await buscarClientes(event.target.value as string, history)
                .then((res) => {
                    setListaClientes(res);
                    setLoadingCliente(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaClientes([]);
                        setLoadingCliente(false);
                    }
                })
        }
        if (event !== null && event.target.value !== "" && reason === "input") {
            setLoadingCliente(true);
            getCliente();
        }
        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]+", 'g').exec(option)
            let tempPedido = novoPedido
            tempPedido.cliente = parseInt(cod ? cod[0] : "");
            if (cod !== null) {
                if (listaClientes !== undefined) {
                    for (let index = 0; index < listaClientes.length; index++) {
                        const element = listaClientes[index];
                        if (cod !== null && element.codcli === cod[0]) {
                            if (props.setFieldCliente)
                                props.setFieldCliente(element);
                            break;
                        }
                    }
                }
                setNovoPedido(tempPedido);
            }
        }

        if (reason === "clear") {
            if (props.setFieldCliente)
                props.setFieldCliente(undefined);
        }
    };

    function handleChangeCondicaoPGTO(event: any, option: string, reason: any) {
        let cod = "";
        let desc = "";

        async function getCondicao() {
            if (new RegExp("[0-9]+", 'g').test(event.target.value)) {
                cod = event.target.value as string;
            } else {
                desc = event.target.value as string;
            }
            await buscarCondPGTO(cod, desc, history)
                .then((res) => {
                    setListaCondPGTO(res);
                    setLoadingCondicaoPGTO(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaCondPGTO([]);
                        setLoadingCondicaoPGTO(false);
                    }
                })
        }
        if (event !== null && event.target.value !== "" && reason === "input") {
            setLoadingCondicaoPGTO(true);
            getCondicao();
        }
        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]+").exec(option)
            let tempPedido = novoPedido
            tempPedido.condpag = parseInt(cod ? cod[0] : "");
            if (cod !== null) {
                if (listaCondPGTO !== undefined) {
                    for (let index = 0; index < listaCondPGTO.length; index++) {
                        const element = listaCondPGTO[index];
                        if (cod !== null && element.codcpg === cod[0]) {
                            if (props.setFieldCondPagamento)
                                props.setFieldCondPagamento(element);
                            break;
                        }
                    }
                }
                setNovoPedido(tempPedido);
            }
        }
    };


    function handleChangeFormaPGTO(event: any, option: string, reason: any) {
        let cod = "";
        let desc = "";

        async function getForma() {
            if (new RegExp("[0-9]+", 'g').test(event.target.value)) {
                cod = event.target.value as string;
            } else {
                desc = event.target.value as string;
            }
            await buscarFormaPGTO(cod, desc, history)
                .then((res) => {
                    setListaFormaPGTO(res);
                    setLoadingFormaPGTO(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaFormaPGTO([]);
                        setLoadingFormaPGTO(false);
                    }
                })
        }
        if (reason === "input" && event !== null && event.target.value !== "") {
            setLoadingFormaPGTO(true);
            getForma();
        }
        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]+").exec(option)
            let tempPedido = novoPedido
            tempPedido.formapag = cod ? cod[0] : ""
            if (cod !== null) {
                if (listaFormaPGTO !== undefined) {
                    for (let index = 0; index < listaFormaPGTO.length; index++) {
                        const element = listaFormaPGTO[index];
                        if (cod !== null && element.codfpg === cod[0]) {
                            if (props.setFieldFormaPagamento)
                                props.setFieldFormaPagamento(element);
                            break;
                        }
                    }
                }
                setNovoPedido(tempPedido);
            }
        }
    };


    const CssTextField = withStyles({
        root: {
            '& label.Mui-focused': {
                color: 'white',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'yellow',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: '#ccc',
                },
                '&:hover fieldset': {
                    borderColor: '#ccc',
                },
                '&.Mui-focused fieldset': {
                    borderColor: '#ccc',
                    borderWidth: '1px'
                },
            },
        },
    })(TextField);

    return (
        <div className="novo-pedido-cabecalho">
            <div className="novo-pedido-form-row">
                {props.setFieldCliente ?
                    <>
                        <div className="novo-pedido-form-column-cliente">
                            <div className="novo-pedido-form-field">
                                <label htmlFor="np-combobox-cliente">Cliente</label>
                                <FieldDropdownVer2
                                    value={props.fieldCliente !== undefined ? props.fieldCliente : ""}
                                    id="np-combobox-cliente"
                                    options={listaClientes || []}
                                    loading={loadingCliente}
                                    select={(option: Cliente, value: Cliente) => option.codcli === value.codcli}
                                    label={(option: Cliente) => option.codcli !== undefined ? "[" + option.codcli + "] " + option.nomcli : ""}
                                    onChange={(event, option, reason) => handleChangeCliente(event, option, reason)}
                                    noOptionsText={"Digite um código ou nome válido"}
                                />
                            </div>
                        </div>
                        <div className="novo-pedido-form-column">
                            {props.fieldCliente !== undefined ?
                                <div className="novo-pedido-form-field">
                                    <Typography><span className='weight-bold'>Endereço: </span> {props.fieldCliente?.endcli}</Typography>
                                    <Typography><span className='weight-bold'>Cidade/UF: </span> {props.fieldCliente?.cidcli + "/" + props.fieldCliente?.sigufs}</Typography>
                                    <Typography><span className='weight-bold'>CPF/CNPJ: </span> {props.fieldCliente?.cgccpf}</Typography>
                                </div>
                                :
                                <></>
                            }
                        </div>
                    </>
                    :
                    <></>
                }
                {props.setFieldCondPagamento ?
                    <div className="novo-pedido-form-column">
                        <div className="novo-pedido-form-field">
                            <label htmlFor="np-combobox-condicao-pgto">Condição de Pagamento</label>
                            <FieldDropdownVer2
                                value={props.fieldCondPagamento !== undefined ? props.fieldCondPagamento : ""}
                                id="np-combobox-condicao-pgto"
                                options={listaCondPGTO || []}
                                loading={loadingCondicaoPGTO}
                                select={(option: CondicaoPagamento, value: CondicaoPagamento) => option.codcpg === value.codcpg}
                                label={(option: CondicaoPagamento) => option.codcpg !== undefined ? "[" + option.codcpg + "] " + option.descpg : ""}
                                onChange={(event, option, reason) => handleChangeCondicaoPGTO(event, option, reason)}
                                noOptionsText={"Digite um código ou descrição válido"}
                            />
                        </div>
                    </div>
                    :
                    <></>
                }
                {props.setFieldFormaPagamento ?
                    <div className="novo-pedido-form-column">
                        <div className="novo-pedido-form-field">
                            <label htmlFor="user">Forma de Pagamento</label>
                            <FieldDropdownVer2
                                value={props.fieldFormaPagamento !== undefined ? props.fieldFormaPagamento : ""}
                                id="np-combobox-forma-pgto"
                                options={listaFormaPGTO || []}
                                loading={loadingFormaPGTO}
                                select={(option: FormaPagamento, value: FormaPagamento) => option.codfpg === value.codfpg}
                                label={(option: FormaPagamento) => option.codfpg !== undefined ? "[" + option.codfpg + "] " + option.desfpg : ""}
                                onChange={(event, option, reason) => handleChangeFormaPGTO(event, option, reason)}
                                noOptionsText={"Digite um código ou descrição válido"}
                            />
                        </div>
                    </div>
                    :
                    <></>
                }
            </div>
        </div>
    )
}